export default __webpack_public_path__ + "static/media/harvard.4e093086.jpg";